import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader'
import { MapContainer, TileLayer } from 'react-leaflet'
import { IndiaMapTitle } from '../../../../Utils/Constants'
import { indiaMapProps, indiaMapSubHeading } from '../../../../Data/MiscellaneousData/MapsData'

const MapContainerAny = MapContainer as any;
const TileLayerAny = TileLayer as any;

export default function IndiaMap() {
    return (
        <Col sm={6}>
            <Card>
                <CommonCardHeader title={IndiaMapTitle} subTitle={indiaMapSubHeading} />
                <CardBody className="map-z-index">
                    <MapContainerAny className='jvector-map-height custom-map' {...indiaMapProps}>
                        <TileLayerAny url='http://{s}.tile.osm.org/{z}/{x}/{y}.png' />
                    </MapContainerAny>
                </CardBody>
            </Card>
        </Col>
    )
}
